var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconClose24 = function SvgIconClose24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.3,
    d: "M19.018 6.41 17.608 5l-5.59 5.59L6.428 5l-1.41 1.41 5.59 5.59-5.59 5.59L6.428 19l5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59 5.59-5.59Z"
  })));
};
export default SvgIconClose24;